import { getBaseApiUrl } from "./generic";

// User endpoints
export const getRegisterUserUrl = () =>
  `${getBaseApiUrl()}api/v1/user/register/new`;
export const getLoginWithOtpUrl = () => `${getBaseApiUrl()}api/v1/user/login`;
export const getResendOtpUrl = () => `${getBaseApiUrl()}api/v1/user/resend/otp`;
export const getVerifyOtpUrl = () => `${getBaseApiUrl()}api/v1/user/verify/otp`;
export const getTokenRefreshUrl = () =>
  `${getBaseApiUrl()}api/v1/user/token/refresh`;
export const getUserFeedbackUrl = () =>
  `${getBaseApiUrl()}api/v1/user/feedback`;
export const getUserFeedbacksUrl = () =>
  `${getBaseApiUrl()}api/v1/user/feedbacks`;
export const getSaveUserDetailsUrl = () =>
  `${getBaseApiUrl()}api/v1/user/save/details`;

// Booking endpoints
export const getCreateBookingUrl = () => `${getBaseApiUrl()}api/v1/booking`;
export const getBookingByIdUrl = (id) =>
  `${getBaseApiUrl()}api/v1/booking/${id}`;
export const getAllBookingsUrl = () => `${getBaseApiUrl()}api/v1/booking`;
export const getUserBookingsUrl = () =>
  `${getBaseApiUrl()}api/v1/booking/user/my-bookings`;
export const getUpdateBookingUrl = (id) =>
  `${getBaseApiUrl()}api/v1/booking/${id}`;
export const getCancelBookingUrl = (id) =>
  `${getBaseApiUrl()}api/v1/booking/${id}`;
export const getConfirmBookingUrl = (bookingId) =>
  `${getBaseApiUrl()}api/v1/booking/confirm/${bookingId}`;
export const getVerifyPaymentUrl = () =>
  `${getBaseApiUrl()}api/v1/booking/verify-payment`;
export const getBookingStatisticsUrl = () =>
  `${getBaseApiUrl()}api/v1/booking/admin/statistics`;

// Slot endpoints
export const getAvailableSlotsUrl = (date, sport, location) => {
  const baseUrl = `${getBaseApiUrl()}api/v1/slots/available`;

  let query = "";

  query += `date=${date}`;
  query += `&sport=${sport}`;
  query += `&location=${location}`;

  const queryString = query.toString();
  return `${baseUrl}?${queryString}`;
};

export const getUpdateSlotsUrl = () => `${getBaseApiUrl()}api/v1/slots/update`;
export const getUpdateSlotsAllUrl = () =>
  `${getBaseApiUrl()}api/v1/slots/update/all`;

// Payment endpoints
export const getPaymentTestUrl = () => `${getBaseApiUrl()}api/v1/payment/test`;
export const getPaymentPollStatusUrl = () =>
  `${getBaseApiUrl()}api/v1/payment/poll-status`;
export const getPaymentCheckBookingUrl = (bookingId) =>
  `${getBaseApiUrl()}api/v1/payment/check-booking/${bookingId}`;
export const getPaymentStatusUrl = () =>
  `${getBaseApiUrl()}api/v1/payment/status`;

// Pricing endpoints
export const getPricingConfigsUrl = (sport, location, date) => {
  const baseUrl = `${getBaseApiUrl()}api/v1/pricing/configs/${sport}/${location}`;
  if (date) {
    return `${baseUrl}?date=${date}`;
  }
  return baseUrl;
};
export const getPricingUrl = (sport, location, turfNumber) =>
  `${getBaseApiUrl()}api/v1/pricing/${sport}/${location}/${turfNumber}`;
export const getCreatePricingConfigUrl = () =>
  `${getBaseApiUrl()}api/v1/pricing/config`;
export const getUpdatePricingConfigUrl = (id) =>
  `${getBaseApiUrl()}api/v1/pricing/config/${id}`;
export const getAllPricingConfigsUrl = () =>
  `${getBaseApiUrl()}api/v1/pricing/config/all`;
export const getSpecialOffersUrl = () =>
  `${getBaseApiUrl()}api/v1/pricing/config/special-offers`;
export const getDeletePricingConfigUrl = (id) =>
  `${getBaseApiUrl()}api/v1/pricing/config/${id}`;
export const getUpsertPricingUrl = () =>
  `${getBaseApiUrl()}api/v1/pricing/upsert`;
export const getSimplePricingUrl = (sport, location) =>
  `${getBaseApiUrl()}api/v1/pricing/simple/${sport}/${location}`;

// Settings endpoints
export const getLocationSettingsUrl = (location) =>
  `${getBaseApiUrl()}api/v1/settings/${location}`;
export const getUpdateInvoicePrefixUrl = (location) =>
  `${getBaseApiUrl()}api/v1/settings/${location}/invoice-prefix`;
export const getUpdateFinancialYearUrl = () =>
  `${getBaseApiUrl()}api/v1/settings/update-financial-year`;
export const getGenerateInvoiceNumberUrl = (location) =>
  `${getBaseApiUrl()}api/v1/settings/${location}/invoice-number`;

// Notification Settings endpoints
export const getNotificationSettingsUrl = (location) =>
  `${getBaseApiUrl()}api/v1/settings/${location}/notification-settings`;
export const getUpdateNotificationSettingsUrl = (location) =>
  `${getBaseApiUrl()}api/v1/settings/${location}/notification-settings`;
export const getAdminEmailsUrl = (location) =>
  `${getBaseApiUrl()}api/v1/settings/${location}/notification-settings/admin-email`;
export const getAdminPhoneNumbersUrl = (location) =>
  `${getBaseApiUrl()}api/v1/settings/${location}/notification-settings/admin-phone`;
export const getTestEmailTemplateUrl = (location) =>
  `${getBaseApiUrl()}api/v1/settings/test-email/${location}`;
export const getTestSmsTemplateUrl = (location) =>
  `${getBaseApiUrl()}api/v1/settings/test-sms/${location}`;

// Admin Portal endpoints
export const getAllUsersUrl = () => `${getBaseApiUrl()}api/v1/user/all`;
export const searchUsersUrl = () => `${getBaseApiUrl()}api/v1/user/search`;
export const getAllLocationsUrl = () => `${getBaseApiUrl()}api/v1/locations`;
export const createUserUrl = () => `${getBaseApiUrl()}api/v1/user/create`;
export const updateUserUrl = (id) => `${getBaseApiUrl()}api/v1/user/${id}`;
export const deleteUserUrl = (id) => `${getBaseApiUrl()}api/v1/user/${id}`;
export const updateLocationUrl = (id) =>
  `${getBaseApiUrl()}api/v1/locations/${id}`;
export const assignRolesLocationsUrl = () =>
  `${getBaseApiUrl()}api/v1/user/assign/roles-locations`;

// Day Mapping endpoints
export const getDayMappingsUrl = (location) =>
  `${getBaseApiUrl()}api/v1/settings/${location}/day-mappings`;
export const getUpdateDayMappingsUrl = (location) =>
  `${getBaseApiUrl()}api/v1/settings/${location}/day-mappings`;
export const getResetDayMappingsUrl = (location) =>
  `${getBaseApiUrl()}api/v1/settings/${location}/day-mappings/reset`;

// Holiday endpoints
export const getBlockDayUrl = () => `${getBaseApiUrl()}holiday/block`;
export const getUnblockDayUrl = () => `${getBaseApiUrl()}holiday/unblock`;
export const getIsDayBlockedUrl = () => `${getBaseApiUrl()}holiday/is-blocked`;
export const getCheckBookingAllowedUrl = (location, sport, date) =>
  `${getBaseApiUrl()}api/v1/holiday/check-booking/${location}/${sport}?date=${date}`;
export const getHolidayDatesUrl = (location, sport) =>
  `${getBaseApiUrl()}api/v1/holiday/dates/${location}/${sport}`;
export const getHolidayUpdateUrl = () =>
  `${getBaseApiUrl()}api/v1/holiday/update`;

// Special Schedule endpoints
export const getSpecialScheduleDatesUrl = (location, sport) =>
  `${getBaseApiUrl()}api/v1/special-schedule/dates/${location}/${sport}`;
export const getSpecialScheduleUpdateUrl = () =>
  `${getBaseApiUrl()}api/v1/special-schedule/update`;
export const getCheckDatePresenceUrl = (location, sport, date) =>
  `${getBaseApiUrl()}api/v1/special-schedule/check-date/${location}/${sport}?date=${date}`;

// Invoice endpoints
export const getInvoiceDownloadUrl = (id) =>
  `${getBaseApiUrl()}api/v1/invoice/download/${id}`;

// Legacy endpoints for backward compatibility (deprecated)
export const getNewBookingUrl = (sport, location) => {
  if (sport === "Cricket Net") {
    return `${getBaseApiUrl()}api/v1/booking/new/cricket-net`;
  }
  if (sport === "Pickle Ball") {
    return `${getBaseApiUrl()}api/v1/booking/new/pickle-ball`;
  }

  return `${getBaseApiUrl()}api/v1/booking/new`;
};

export const getMakeSlotAvailableUrl = (sport) => {
  if (sport === "Cricket Net") {
    return `${getBaseApiUrl()}api/v1/booking/make-slots-available/cricket-net`;
  }
  if (sport === "Pickle Ball") {
    return `${getBaseApiUrl()}api/v1/booking/make-slots-available/pickle-ball`;
  }

  return `${getBaseApiUrl()}api/v1/booking/make-slots-available`;
};

export const getFetchAvailableSlotsUrl = (sport, location) => {
  if (sport === "Cricket Net") {
    return `${getBaseApiUrl()}api/v1/booking/available-slots/cricket-net/${location}`;
  }
  if (sport === "Pickle Ball") {
    return `${getBaseApiUrl()}api/v1/booking/available-slots/pickle-ball/${location}`;
  }

  return `${getBaseApiUrl()}api/v1/booking/available-slots/football/${location}`;
};

export const getBlockUnblockSlotUrl = (sport, location) => {
  if (sport === "Cricket Net") {
    return `${getBaseApiUrl()}api/v1/booking/block-slots/cricket-net`;
  }
  if (sport === "Pickle Ball") {
    return `${getBaseApiUrl()}api/v1/booking/block-slots/pickle-ball`;
  }
  return `${getBaseApiUrl()}api/v1/booking/block-slots`;
};

export const getFetchBookingSettingUrl = (
  sport,
  location,
  includeSpecialOffers = false
) => {
  // Map sport names to API format
  const sportMap = {
    "Cricket Net": "cricket-net",
    "Pickle Ball": "pickle-ball",
    Football: "football",
    "Box Cricket": "box-cricket",
  };

  const mappedSport =
    sportMap[sport] || sport.toLowerCase().replace(/\s+/g, "-");

  const baseUrl = `${getBaseApiUrl()}api/v1/pricing/configs/${mappedSport}/${location}`;

  if (includeSpecialOffers) {
    return `${baseUrl}?include_special_offers=true`;
  }

  return baseUrl;
};

export const getUpdateBookingSettingUrl = (sport, location) => {
  if (sport === "Cricket Net") {
    return `${getBaseApiUrl()}api/v1/booking/setting/cricket-net/${location}`;
  }
  if (sport === "Pickle Ball") {
    return `${getBaseApiUrl()}api/v1/booking/setting/pickle-ball/${location}`;
  }

  return `${getBaseApiUrl()}api/v1/booking/setting/football/${location}`;
};

// Equipment endpoints
export const getEquipmentOptionsUrl = (sport, location) => {
  // Map sport names to API format
  const sportMap = {
    "Cricket Net": "cricket-net",
    "Pickle Ball": "pickle-ball",
    Football: "football",
    "Box Cricket": "box-cricket",
  };

  const mappedSport =
    sportMap[sport] || sport.toLowerCase().replace(/\s+/g, "-");

  return `${getBaseApiUrl()}api/v1/booking/equipment-options/${mappedSport}/${location}`;
};

// Equipment Config endpoints (Admin)
export const getEquipmentConfigsUrl = () =>
  `${getBaseApiUrl()}api/v1/equipment-config`;
export const getEquipmentConfigByIdUrl = (id) =>
  `${getBaseApiUrl()}api/v1/equipment-config/${id}`;
export const createEquipmentConfigUrl = () =>
  `${getBaseApiUrl()}api/v1/equipment-config`;
export const updateEquipmentConfigUrl = (id) =>
  `${getBaseApiUrl()}api/v1/equipment-config/${id}`;
export const deleteEquipmentConfigUrl = (id) =>
  `${getBaseApiUrl()}api/v1/equipment-config/${id}`;

// Activity Log endpoints
export const getActivityLogsUrl = () =>
  `${getBaseApiUrl()}api/v1/activity-logs`;
export const getActivitySummaryUrl = () =>
  `${getBaseApiUrl()}api/v1/activity-logs/summary`;
